<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Admin Dashboard
            </h2>
        </template>

        <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
            <div class="px-4 py-5 bg-white sm:p-6 shadow-xl rounded-md">
                <div class="flex items-center justify-between">
                    <h3 class="text-xl">Latest Partners</h3>

                    <div class="flex items-center justify-end">
                        <inertia-link
                            v-if="permissions.partners.create"
                            class="rounded-md border border-transparent bg-gray-800 inline-flex items-center px-4 py-2 text-xs text-white uppercase tracking-widest font-semibold hover:bg-gray-700 transition"
                            :href="create_partner_url">
                            Create Partner
                        </inertia-link>
                    </div>
                </div>

                <partner-list :partners="partners"/>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout';
import {usePage} from '@inertiajs/inertia-vue3';
import CopyText from '@/Components/CopyText';
import PartnerList from '@/Pages/Partners/PartnerList.vue';

export default {
    props: ['partners', 'create_partner_url'],

    components: {
        PartnerList,
        AppLayout,
        CopyText,
    },

    setup() {
        return {
            user: usePage().props.value.auth.user,
            permissions: usePage().props.value.auth.permissions,
        };
    },
};
</script>
